import { AppFeatureTypes } from './AppFeatureTypes';

export const appFeatureDefaults: AppFeatureTypes = {
  is_place_order_v2_enabled: false,
  is_new_delta_bank: false,
  is_recaptcha_singleton_enabled: false,
  is_chart_backend_saving_enabled: false,
  is_algo_marketplace_enabled: false,
  sentry_trace_sample_rate: 0.005,
};
